import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService, AuthService } from '@app/core/services';
import { IntlService } from '@progress/kendo-angular-intl';
import { EditUserPasswordComponent, ConfigDateComponent, ConfigRangeDateComponent } from '@app/core/windows';
import { User } from '@app/core/models';
import { environment } from '@environments/environment';
import { VehiclesReportComponent, ServicesReportComponent, ExpensesReportComponent, DiarioReportComponent } from '@app/core/reports'


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
  //Window
  @ViewChild(EditUserPasswordComponent, {static: false}) window !: EditUserPasswordComponent;

  //Report - Vehicles
  @ViewChild(VehiclesReportComponent, {static: false}) report_veh !: VehiclesReportComponent;

  //Report - Services
  @ViewChild(ServicesReportComponent, {static: false}) report_ser !: ServicesReportComponent;

  //Report - Expenses
  @ViewChild(ExpensesReportComponent, {static: false}) report_exp !: ExpensesReportComponent;

  //Report - Diario
  @ViewChild(DiarioReportComponent, {static: false}) report_dia !: DiarioReportComponent;

  //Config - Date
  @ViewChild(ConfigDateComponent, {static: false}) config_date !: ConfigDateComponent;

  //Config - Range Date
  @ViewChild(ConfigRangeDateComponent, {static: false}) config_range !: ConfigRangeDateComponent;

  protected currentUser: User;
  
  protected title = environment.appName;  

  protected version = environment.version;

  protected items: any[] = [];

  protected DEFAULT_USER_IMAGE: any = environment.assets.DEFAULT_USER_IMAGE;

  protected branchName: string = environment.branchName;
  

  constructor(private router: Router, private authService: AuthService, protected alertService: AlertService, protected intl: IntlService) {

    console.log('AppComponent');
    this.authService.currentUser.subscribe(x => { 
      this.currentUser = x;
      if(this.currentUser != null) {
        console.log(this.currentUser);
      }
    });

  }

  get isAdmin() {

   return this.currentUser// && this.currentUser.role === Role.Admin;

  }

  protected logout() {

    this.authService.logout();
    this.router.navigate(['/login']);

  }

  protected windowSaveHandler({mode, dataItem}) {

    this.alertService.showSuccess(`Se modificó con éxito la contraseña del usuario: '${dataItem.user}'`);

  }

  public onSelect(event): void {

    let url: string = event.item.url;
    console.log('SELECT MENU', event, url);

    if (typeof url === 'undefined') {

      event.preventDefault();

    }
    else if (url === 'cerrar_sesion') {

      event.preventDefault();
      let that = this;
      this.alertService.confirm('¿Esta seguro que desea cerrar su sesión?', function(){

        that.logout();

      });

    } else if (url === 'cambiar_contraseña') {

      event.preventDefault();
      this.window.edit(null);

    } else if(url === 'report_xls_vehicles_all') {

      event.preventDefault();
      this.report_veh.name = 'Vehículos (Todos)';
      this.report_veh.downloadByStatus(0);

    } else if(url === 'report_xls_vehicles_ing') {

      event.preventDefault();
      this.report_veh.name = 'Vehículos (Ingresado)';
      this.report_veh.downloadByStatus(1);
      
    } else if(url === 'report_xls_vehicles_por_lib') {

      event.preventDefault();
      this.report_veh.name = 'Vehículos (Por Liberar)';
      this.report_veh.downloadByStatus(2);
    
    } else if(url === 'report_xls_vehicles_cre') {

      event.preventDefault();
      this.report_veh.name = 'Vehículos (A Crédito)';
      this.report_veh.downloadByStatus(4);
    
    } else if(url === 'report_xls_vehicles_lib') {

      event.preventDefault();
      this.report_veh.name = 'Vehículos (Liberado)';
      this.report_veh.downloadByStatus(3);

    } else if(url === 'report_xls_vehicles_by_date') {

      event.preventDefault();
      this.config_date.open({report: url});      
    
    } else if(url === 'report_xls_vehicles_by_range') {

      event.preventDefault();
      this.config_range.open({report: url});

    } else if(url === 'report_xls_services_all') {

      event.preventDefault();
      this.report_ser.name = 'Servicios (Todos)';
      this.report_ser.downloadByStatus(0);
    
    } else if(url === 'report_xls_services_pro') {

      event.preventDefault();
      this.report_ser.name = 'Servicios (En proceso)';
      this.report_ser.downloadByStatus(1);

    } else if(url === 'report_xls_services_pen') {

      event.preventDefault();
      this.report_ser.name = 'Servicios (Pago pendiente)';
      this.report_ser.downloadByStatus(3);

    } else if(url === 'report_xls_services_cre') {

      event.preventDefault();
      this.report_ser.name = 'Servicios (A crédito)';
      this.report_ser.downloadByStatus(4);

    } else if(url === 'report_xls_services_ter') {

      event.preventDefault();
      this.report_ser.name = 'Servicios (Terminado)';
      this.report_ser.downloadByStatus(2);

    } else if(url === 'report_xls_services_by_date') {

      event.preventDefault();
      this.config_date.open({report: url});   
      
    } else if(url === 'report_xls_services_by_range') {

      event.preventDefault();
      this.config_range.open({report: url});

    } else if(url === 'report_xls_expenses_all') {

      event.preventDefault();
      this.report_exp.name = 'Gastos (Todo)';
      this.report_exp.downloadByStatus(2);

    } else if(url === 'report_xls_expenses_by_date') {

      event.preventDefault();
      this.config_date.open({report: url});

    } else if(url === 'report_xls_expenses_by_range') {

      event.preventDefault();
      this.config_range.open({report: url});

    } else if(url === 'report_pdf_diario') {

      event.preventDefault();
      this.config_date.open({report: url});

    } else if(url === 'report_pdf_diario_by_range') {

      event.preventDefault();
      this.config_range.open({report: url});

    } else if( url === 'report_pdf') {

      event.preventDefault();
      this.alertService.showWarning('Módulo en proceso de construcción.');

    } else {

      event.preventDefault();
      this.router.navigate(['/' + url, { }]);

    }
    

    // console.log(this.constructor.name + ":onSelect", event.item, this.contextItem);  

  }

  public onConfigDate(event: any) : void {

    // console.log(event);
    let report: string = event.dataItem.report;
    let date: string = event.dataItem.date;

    if(report === 'report_xls_vehicles_by_date') {

      let s: string = this.formatDate(date);
      this.report_veh.name = `Vehículos (${s})`;
      this.report_veh.downloadByRange({start: date, end: date});

    } else if(report === 'report_xls_services_by_date') {

      let s: string = this.formatDate(date);
      this.report_ser.name = `Servicios (${s})`;
      this.report_ser.downloadByRange({start: date, end: date});

    } else if(report === 'report_xls_expenses_by_date') {

      let s: string = this.formatDate(date);
      this.report_exp.name = `Gastos (${s})`;
      this.report_exp.downloadByRange({start: date, end: date});

    } else if(report === 'report_pdf_diario') {

      let s: string = this.formatDate(date);
      this.report_dia.name = `Reporte Diario (${s})`;
      this.report_dia.date = s;
      this.report_dia.downloadByRange({start: date, end: date}, false);

    }
      
  }

  public onConfigRangeDate(event: any) : void {

    console.log(event);
    let report: string = event.dataItem.report;
    let range = event.dataItem.range;
    
    if(report === 'report_pdf_diario_by_range') {

      let s: string = `Del ${this.formatDate(range.start)} al ${this.formatDate(range.end)}`;
      this.report_dia.name = `Reporte Diario (${s})`;
      this.report_dia.date = s;
      this.report_dia.downloadByRange(range, true);

    }
    else if(report === 'report_xls_expenses_by_range') {

      let s: string = `Del ${this.formatDate(range.start)} al ${this.formatDate(range.end)}`;
      this.report_exp.name = `Gastos (${s})`;
      this.report_exp.downloadByRange(range);

    }
    else if(report === 'report_xls_services_by_range') {

      let s: string = `Del ${this.formatDate(range.start)} al ${this.formatDate(range.end)}`;
      this.report_ser.name = `Gastos (${s})`;
      this.report_ser.downloadByRange(range);

    }
    else if(report === 'report_xls_vehicles_by_range') {

      let s: string = `Del ${this.formatDate(range.start)} al ${this.formatDate(range.end)}`;
      this.report_veh.name = `Gastos (${s})`;
      this.report_veh.downloadByRange(range);

    }
      
  }

  public formatDate(date: string) : string {
    let d: Date = this.intl.parseDate(date, 'yyyy-MM-dd');
    return this.intl.formatDate(d, "dd-MMM-yyyy");
  }

}
